import { useCallback, useEffect, useRef, useState } from "react";
import { getScrollParent } from "@/utils/html";

export function useScrollParent() {
  const [baseElement, setBaseElement] = useState<HTMLElement | null>(null);
  const scrollElement = useRef<HTMLElement | null>(null);

  const scrollTo = useCallback(
    (args: ScrollToOptions) => scrollElement.current?.scrollTo(args),
    []
  );

  useEffect(() => {
    if (baseElement) {
      scrollElement.current = getScrollParent(baseElement);
    }
  }, [baseElement]);

  return {
    scrollTo,
    baseElementRef: setBaseElement,
  };
}
